import { createContext, type Dispatch, type SetStateAction } from "react";

export type OnFormReset = (() => void) | null;
type SetOnFormReset = Dispatch<SetStateAction<OnFormReset>>;
export const AutomatedEmailOnFormResetContext = createContext<SetOnFormReset | null>(null);
